import {
  AttachmentResult,
  SimulatorResultItem,
} from '@sdir/httpclient/lib/clients/aps/application';
import { QualificationType } from '../../../types';
import { RequirementStatus } from '../../../types/requirements';

export const statusTranslationMap: Record<RequirementStatus, string> = {
  [RequirementStatus.Avventer]: 'app.requirements.status.pending',
  [RequirementStatus.Mangler]: 'app.requirements.status.missing',
  [RequirementStatus.Gyldig]: 'app.requirements.status.valid',
  [RequirementStatus.Utgått]: 'app.requirements.status.expired',
};

export const typeTranslationMap: Record<QualificationType, string> = {
  [QualificationType.SeagoingTime]: 'app.requirements.type.seagoing',
  [QualificationType.Course]: 'app.requirements.type.course',
  [QualificationType.Education]: 'app.requirements.type.education',
  [QualificationType.Certificate]: 'app.requirements.type.certificate',
  [QualificationType.Health]: 'app.requirements.type.health',
  [QualificationType.Assessment]: 'app.requirements.type.assessment',
  [QualificationType.AdditionalCompetence]: 'app.requirements.type.additionalcompetence',
  [QualificationType.Confirmation]: 'app.requirements.type.confirmation',
  [QualificationType.Declaration]: 'app.requirements.type.declaration',
  [QualificationType.IdCard]: 'app.requirements.type.idcard',
  [QualificationType.ProfilePicture]: 'app.requirements.type.profilepicture',
  [QualificationType.Signature]: 'app.requirements.type.signature',
  [QualificationType.ApplicationServiceOther]: 'app.requirements.type.foreignid',
  [QualificationType.Other]: 'app.requirements.type.other',
};

export const calcStatusForReq = (
  qualification: SimulatorResultItem,
  hasValidAttachments: boolean
) => {
  if (qualification.status) return RequirementStatus.Gyldig;
  if (hasValidAttachments) return RequirementStatus.Avventer;
  return RequirementStatus.Mangler;
};

export const groupAttachments = (
  attachments: AttachmentResult[]
): { [attachmentGroup: string]: AttachmentResult[] } => {
  return attachments.reduce((res, x) => {
    const group = x.group || 'ungrouped';
    return {
      ...res,
      [group]: [...(res[group] || []), x],
    };
  }, {} as { [attachmentGroup: string]: AttachmentResult[] });
};
